import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/toaster/showToast";
import { useParams } from "react-router-dom";
import { useUpdateUserRewardWalletMutation } from "src/services/RewardService";
import UpdateGuestRewardWalletForm from "./UpdateGuestRewardWalletForm";

export type UpdateGuestRewardWalletFormValues = {
  otp: string;
  amountToBeUpdate: string;
};

type Props = {
  onClose: () => void;
  walletAmountData: string;
};

const UpdateGuestRewardWalletFormWrapper = ({
  onClose,
  walletAmountData,
}: Props) => {
  const [updateWallet] = useUpdateUserRewardWalletMutation();
  const [wantToDisabledFiled, setWantToDisabledFiled] = useState(false);

  const { guestId } = useParams();

  // Form Initial Values
  const initialValues: UpdateGuestRewardWalletFormValues = {
    otp: "",
    amountToBeUpdate: walletAmountData,
  };

  // Validation Schema
  const validationSchema = object().shape({
    otp: string().required("Please enter otp"),
    amountToBeUpdate: string().required("Please enter amount To BeUpdate"),
  });

  // Handle Submit
  const handleSubmit = (
    values: UpdateGuestRewardWalletFormValues,
    {
      setSubmitting,
      resetForm,
    }: FormikHelpers<UpdateGuestRewardWalletFormValues>
  ) => {
    const formattedValues = {
      otp: values?.otp,
      amountToBeUpdate: values?.amountToBeUpdate,
      userId: guestId,
    };

    updateWallet(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          setWantToDisabledFiled(false);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <UpdateGuestRewardWalletForm
              setWantToDisabledFiled={setWantToDisabledFiled}
              wantToDisabledFiled={wantToDisabledFiled}
              formikProps={formikProps}
              onClose={onClose}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default UpdateGuestRewardWalletFormWrapper;
